import {Badge} from '@mantine/core'
import {formatLocalDate} from '../../calendar/formatter/formatLocalDate.ts'
import dayjs from 'dayjs'
import {useUserSettings} from '../../../providers/userSettings/useUserSettings.ts'
import type {Subscription} from '@package/shared'

type Props = {subscription: Subscription}

export const SubscriptionBadge = ({subscription}: Props) => {
  const {userSettings} = useUserSettings()

  if (!subscription.isSubscribed) return null

  if (subscription.isCanceled)
    return (
      <Badge color={'red'}>
        Canceled to{' '}
        {!!subscription?.subscriptionEndDate && formatLocalDate(dayjs(subscription.subscriptionEndDate), userSettings)}
      </Badge>
    )

  if (subscription.isTrial)
    return (
      <Badge color={'green'}>
        Trial until{' '}
        {!!subscription?.subscriptionEndDate && formatLocalDate(dayjs(subscription.subscriptionEndDate), userSettings)}
      </Badge>
    )

  return <Badge color={'green'}>Subscribed</Badge>
}
